import { render, staticRenderFns } from "./work-packages-new.vue?vue&type=template&id=58d1c3f4&scoped=true"
import script from "./work-packages-new.vue?vue&type=script&lang=js"
export * from "./work-packages-new.vue?vue&type=script&lang=js"
import style0 from "./work-packages-new.vue?vue&type=style&index=0&id=58d1c3f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d1c3f4",
  null
  
)

export default component.exports